'use client';
import React, { useEffect, useMemo, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { fetchBestsellers } from '../../services/apiService';
import { normalizeBestseller } from './HeroShowcase';
import ProductRailPanel from './ProductRailPanel';

/**
 * Bestsellers as a swipeable, ranked rail on the off-white surface.
 *
 * Only the mobile tree of Home renders this now — on desktop the bestsellers
 * live in the hero's showcase (HeroShowcase). It is built responsive anyway,
 * so it holds up on a tablet or if it is ever placed on a wide page again.
 */
const Bestseller = React.memo(() => {
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetchBestsellers();
        if (!cancelled) {
          setProducts(response?.success ? (response.data?.products || []).slice(0, 20) : []);
        }
      } catch {
        if (!cancelled) setProducts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const items = useMemo(
    () => products.map(normalizeBestseller).filter((p) => p.pharmacode),
    [products]
  );

  return (
    <ProductRailPanel
      tone="surface"
      lead={t('home.bestseller.title')}
      highlight={t('home.bestseller.titleHighlight')}
      subtitle={t('home.bestseller.subtitle')}
      items={items}
      loading={loading}
      variant="bestseller"
      showRank
      viewAllLabel={t('home.bestseller.viewAll')}
      viewAllPath="/products?view=bestseller"
    />
  );
});

Bestseller.displayName = 'Bestseller';

export default Bestseller;
